import React from 'react'
import { Card } from '@sainsburys-tech/fable'
import PropTypes from 'prop-types'
import GreenTick from '../../../assets/GreenTick.svg'
import passIcon from '../../../assets/PassIcon.svg'
import { visitPassActionTypes } from '../../../utils/constants'

const PassView = (props) => {
  const { pass } = props
  const isApproved = pass.actionTypeId === visitPassActionTypes.approved

  return (
    <div className="dsib-passView">
      <Card
        orientation="horizontal"
        hasBorder
        contentAlignment="left"
        className="dsib-passView__card"
      >
        <div style={{ display: 'flex' }}>
          <div className="dsib-passView__leading" aria-hidden="true">
            <img className="dsib-passView__leadingIcon" src={passIcon} alt="" />
          </div>

          <Card.Content label={pass.passName} labelSize="Display3" />
        </div>

        <Card.Actions className="dsib-passView__actions">
          {isApproved && (
            <img className="dsib-passView__tick" src={GreenTick} alt="Approved" />
          )}
        </Card.Actions>
      </Card>
    </div>
  )
}

PassView.propTypes = {
  pass: PropTypes.shape({
    passId: PropTypes.number.isRequired,
    passName: PropTypes.string.isRequired,
    actionTypeId: PropTypes.number.isRequired
  }).isRequired
}

export default PassView
